/**
 * 常量字典数据
 */
export class DictionaryBase extends Map {
    showName;
    constructor(name, dataList, keyId = 'id', symbolId = 'symbol') {
        super();
        this.showName = name;
        this.setList(dataList, keyId, symbolId);
    }
    setList(dataList, keyId = 'id', symbolId = 'symbol') {
        this.clear();
        if (Array.isArray(dataList)) {
            dataList.forEach(item => {
                this.set(item[keyId], item);
                if (item[symbolId] != null) {
                    Object.defineProperty(this, item[symbolId], {
                        get: function () {
                            return item[keyId];
                        },
                    });
                }
            });
        }
    }
    getList(valueId = 'name', parentIdKey = 'parentId', filter) {
        const temp = [];
        this.forEach((value, key) => {
            let obj = {
                id: key,
                name: typeof value === 'string' ? value : String(value[valueId]),
                parentId: value[parentIdKey],
            };
            if (typeof value !== 'string') {
                obj = {
                    ...value,
                    ...obj,
                };
            }
            if (typeof filter !== 'function' || filter(obj)) {
                temp.push(obj);
            }
        });
        return temp;
    }
    getValue(id, valueId = 'name') {
        // 如果id为boolean类型，则自动转换为0和1
        if (typeof id === 'boolean') {
            id = id ? 1 : 0;
        }
        const obj = this.get(id);
        return obj == null ? '' : obj[valueId];
    }
}
